export const MOBILE_UX_MODE_MAX_WIDTH = 640;

export const MINIMUM_WIDTH_FOR_REGULAR_NOTE_PREVIEW = 520;
